import { useMFA } from "contexts/MFAContext";

export default useMFA;
